var
    productId = window.productProps.productId
    ;

getTodayProductViews(productId);

function getTodayProductViews(productId){

    var viewsCountContainers = jQuery('.today-product-views');

    jQuery.ajax({
        url: 'index.php?route=product/product/getTodayProductViews/:'+productId,
        success: function(viewsCount){
            jQuery(viewsCountContainers).addClass('loaded').text(+viewsCount);
        }
    });

}


// WEBPACK FOOTER //
// ./assets/javascript/productpage.js